<template>
  <div class="contact-types-block">
    <vx-card title="Contact Types" class="mb-6">
      <template slot="actions">
        <vs-button @click="selected()">New Contact Type</vs-button>
      </template>
      <form name="contactTypes">
        <div class="vx-row">
          <div class="vx-col w-full ">
            <tc-table
              :dataList="contactTypes"
              @filter="filter"
              @selected="selected"
              :tbody="tbody"
              :settings="{
                externalFilters: {
                  show: false
                }
              }">
              <template slot="thead">
                <vs-th sort-key="name">Name</vs-th>
                <vs-th>Department/Company Name</vs-th>
                <vs-th>Actions</vs-th>
              </template>
            </tc-table>
          </div>
        </div>
      </form>
    </vx-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ContactTypesTableBody from '@/components/tc-toble-body/ContactTypes.vue';
export default {
  data: () => ({
    tbody: {
      component: ContactTypesTableBody
    }
  }),
  computed: {
    ...mapState('visitManagement', ['contactTypes'])
  },
  methods: {
    async filter (params) {
      await this.$store.dispatch('visitManagement/fetchContactTypes', params);
    },
    selected (data) {
      this.$root.$tcPopup.show({
        data: data || {},
        title: data ? 'Edit Contact Types' : 'New Contact Types',
        component: 'FormContactType',
        acceptText: 'Save'
      })
    }
  }
}
</script>